import { useMemo } from 'react';

import { CustomStyle } from './style';

// 商品没找到提示
export default function UnfoundTips(props) {
  const { searchEngineProcess, globalSearchKeyword, greekCharTipList } = props;

  return useMemo(() => {
    if (searchEngineProcess?.hasModelSuggest) {
      return (
        <CustomStyle className="mb-[15px] rounded-[10px] bg-[#FFF1AA] p-[13px_20px] text-[16px] text-[#444]">
          没有找到与“
          <strong
            dangerouslySetInnerHTML={{
              __html: searchEngineProcess?.searchValidWordLight || globalSearchKeyword,
            }}
          ></strong>
          ” 相匹配的自营商品，已为您返回“
          <strong
            dangerouslySetInnerHTML={{
              __html: searchEngineProcess?.searchValidWord,
            }}
          ></strong>
          ”的结果，请注意甄别
        </CustomStyle>
      );
    } else if (greekCharTipList?.length >= 2) {
      return (
        <CustomStyle className="mb-[15px] rounded-[10px] bg-[#FFF1AA] p-[13px_20px] text-[16px] text-[#444]">
          搜索词“
          <strong
            dangerouslySetInnerHTML={{
              __html: greekCharTipList?.[0],
            }}
          ></strong>
          ” 标红的部分为希腊大写字母，其小写形式为“
          <strong>{greekCharTipList?.[1]}</strong>”
        </CustomStyle>
      );
    } else if (searchEngineProcess?.keywordNotFullMatch) {
      if (searchEngineProcess?.rerankMap?.hasOvs) {
        return (
          <div className="mb-[15px] rounded-[10px] bg-[#FFF1AA] p-[13px_20px] text-[16px] text-[#444]">
            没有找到完全匹配的自营商品，立创订货/海外代购可能有完全匹配型号
          </div>
        );
      } else {
        return (
          <div className="mb-[15px] rounded-[10px] bg-[#FFF1AA] p-[13px_20px] text-[16px] text-[#444]">
            没有找到与“<strong>{globalSearchKeyword}</strong>
            ”完全匹配的商品，请注意甄别
          </div>
        );
      }
    } else {
      return <></>;
    }
  }, [searchEngineProcess, globalSearchKeyword, greekCharTipList]);
}
